const colors = {
  primary: "#121212",
  accent: "white",
  blue: "#0072ff",
  special: "#ffb100"
};

export default {
  colors
};



// WEBPACK FOOTER //
// ./src/theme/index.js